import { bindRequestLogic } from './utils'
import SharingTypes from '../actionTypes/sharing'
import { sharingAPI } from '../api'

const getSharings = bindRequestLogic({
  clientFunc: sharingAPI.getSharings,
  type: SharingTypes.GET_LIST_OF_SHARING_REQUEST,
  successType: SharingTypes.GET_LIST_OF_SHARING_SUCCESS,
  failType: SharingTypes.GET_LIST_OF_SHARING_FAILED,
  isQueryParam: true
})

export default [getSharings]
